import { Button, Tooltip } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import React from 'react';

import MdcFormatVerticalAlignTop from '@meronex/icons/mdc/MdcFormatVerticalAlignTop';
import MdcFormatVerticalAlignCenter from '@meronex/icons/mdc/MdcFormatVerticalAlignCenter';
import MdcFormatVerticalAlignBottom from '@meronex/icons/mdc/MdcFormatVerticalAlignBottom';

const fixValue = value => {
  if (value === 'center') {
    return 'middle';
  }
  return value;
};

const verticalAligns = ['top', 'middle', 'bottom'];
const icons = {
  top: (
    <span className="bp5-icon">
      <MdcFormatVerticalAlignTop />
    </span>
  ),
  middle: (
    <span className="bp5-icon">
      <MdcFormatVerticalAlignCenter />
    </span>
  ),
  bottom: (
    <span className="bp5-icon">
      <MdcFormatVerticalAlignBottom />
    </span>
  ),
};

const TextVerticalAlignSelect = ({ onChange, value: rawValue }) => {
  const value = fixValue(rawValue);
  const label = `Vertical align ${value}`;
  return (
    <Tooltip content={label} key={value} placement="bottom">
      <Button
        minimal
        icon={icons[value]}
        onClick={() => {
          const currentIndex = verticalAligns.indexOf(value);
          const nextIndex = (currentIndex + 1 + verticalAligns.length) % verticalAligns.length;
          const next = verticalAligns[nextIndex];
          onChange(next);
        }}
      />
    </Tooltip>
  );
};

TextVerticalAlignSelect.defaultProps = {
  onChange: () => {},
  value: 'top',
};

TextVerticalAlignSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default TextVerticalAlignSelect;
